import { Box, Flex, Stack, StackDivider, Text } from "@chakra-ui/react";
import React from "react";
import BoxFlexMobile from "./BoxFlexMobile";
import PriceAveragesComponent from "./PriceAveragesComponent";

function FinancialData(props) {
  //   console.log("props.financialData", Object.keys(props.financialData));
  return (
    <Stack divider={<StackDivider />} spacing="4">
      {(props.financialGraphs ?? []).map((_a) => (
        <PriceAveragesComponent
          key={_a._title}
          {..._a}
        ></PriceAveragesComponent>
      ))}
      {Object.keys(props.financialData).map((key) => (
        // <Text>{"test"}</Text>
        <BoxFlexMobile key={key}>
          <Box flex={1}>{key}</Box>{" "}
          <Box flex={2}>
            {new Intl.NumberFormat("en-US", {
              notation: "compact",
              maximumFractionDigits: 2,
            }).format(props.financialData[key])}
          </Box>{" "}
        </BoxFlexMobile>
      ))}
    </Stack>
  );
}

export default FinancialData;
